// =========================================================
// Login.jsx
// ORION BEACH HOTEL · KITE HOUSE
// ADMIN PANEL
// =========================================================

import { useState } from "react";
import "../styles/login.css";

export default function Login({ onLogin }) {

  const [pass, setPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  // =======================================================
  // LOGIN
  // =======================================================

  const login = () => {

    setError("");

    if (!pass.trim()) {

      setError(
        "Ingresa tu contraseña para continuar."
      );

      return;
    }


    setLoading(true);


    // =====================================================
    // LOGIN ACTUAL
    // =====================================================

    if (pass === "Admin1234") {

      setTimeout(() => {

        setLoading(false);

        onLogin(true);

      }, 500);

    } else {

      setTimeout(() => {

        setLoading(false);

        setError(
          "La contraseña ingresada no es correcta."
        );

      }, 500);

    }

  };


  // =======================================================
  // ENTER
  // =======================================================

  const handleKeyDown = (e) => {

    if (e.key === "Enter") {
      login();
    }

  };


  // =======================================================
  // RENDER
  // =======================================================

  return (

    <main className="login">


      {/* ===================================================
          BACKGROUND
      =================================================== */}

      <div className="login__background">

        <div className="login__glow login__glow--blue"></div>

        <div className="login__glow login__glow--cyan"></div>

        <div className="login__wave login__wave--one"></div>

        <div className="login__wave login__wave--two"></div>

        <div className="login__particles"></div>

      </div>


      {/* ===================================================
          CARD
      =================================================== */}

      <section className="login__card">


        {/* =================================================
            BRAND
        ================================================= */}

        <div className="login__brand">

          <img
            src="/images/logo-orion.png"
            alt="Orion Beach Hotel Kite House"
            className="login__logo"
          />

        </div>


        {/* =================================================
            BRAND DIVIDER
        ================================================= */}

        <div className="login__divider">

          <span></span>

          <i></i>

          <span></span>

        </div>


        {/* =================================================
            TITLE
        ================================================= */}

        <div className="login__heading">

          <span className="login__eyebrow">
            ORION BEACH HOTEL
          </span>

          <h1 className="login__title">
            Panel Administrativo
          </h1>

          <p className="login__subtitle">
            Gestiona la experiencia digital de tu hotel
          </p>

        </div>


        {/* =================================================
            FORM
        ================================================= */}

        <div className="login__form">


          {/* PASSWORD */}

          <div className="login__field">

            <label
              htmlFor="admin-password"
            >
              Contraseña
            </label>


            <div className="login__input-wrapper">

              <span className="login__input-icon">
                🔐
              </span>


              <input
                id="admin-password"
                type={
                  showPassword
                    ? "text"
                    : "password"
                }
                value={pass}
                placeholder="Ingresa tu contraseña"
                className="login__input"
                autoComplete="current-password"
                onChange={(e) => {

                  setPass(
                    e.target.value
                  );

                  setError("");

                }}
                onKeyDown={handleKeyDown}
              />


              <button
                type="button"
                className="login__show"
                onClick={() =>
                  setShowPassword(
                    !showPassword
                  )
                }
                aria-label={
                  showPassword
                    ? "Ocultar contraseña"
                    : "Mostrar contraseña"
                }
              >
                {showPassword
                  ? "◉"
                  : "○"}
              </button>

            </div>

          </div>


          {/* =================================================
              ERROR
          ================================================= */}

          {error && (

            <div className="login__error">

              <span>
                ⚠
              </span>

              <p>
                {error}
              </p>

            </div>

          )}


          {/* =================================================
              BUTTON
          ================================================= */}

          <button
            type="button"
            className="login__button"
            onClick={login}
            disabled={loading}
          >

            {loading ? (

              <>
                <span className="login__spinner"></span>

                Verificando acceso...
              </>

            ) : (

              <>
                Entrar al Panel
                <span className="login__arrow">
                  →
                </span>
              </>

            )}

          </button>

        </div>


        {/* =================================================
            SECURITY
        ================================================= */}

        <div className="login__security">

          <span className="login__security-icon">
            🔒
          </span>

          <span>
            Acceso privado y protegido
          </span>

        </div>


        {/* =================================================
            LOCATION
        ================================================= */}

        <div className="login__location">

          <span>
            BEACH HOTEL
          </span>

          <i></i>

          <span>
            KITE HOUSE
          </span>

          <i></i>

          <span>
            LA GUAJIRA
          </span>

        </div>


      </section>


      {/* ===================================================
          FOOTER
      =================================================== */}

      <div className="login__footer">

        <span>
          © {new Date().getFullYear()} Orion Beach Hotel
        </span>

        <span>
          ·
        </span>

        <span>
          Vive el viento. Descansa en Orion.
        </span>

      </div>

    </main>

  );

}